var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlayEs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-fef220bf-06a2-49b5-a81d-a61ba22f5619",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 243 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "uuid-0d12de85-5c6f-420a-8409-ec7ef2fcde7a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 243,
    height: 72,
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "uuid-a9d4a6c8-0a00-41e2-bfd2-b11bdc2ba9e6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.37,15.21v39.79c-.04.92.28,1.83.9,2.52l.18.18,22.32-22.32v-.37L18.09,12.69c-.56.72-.81,1.62-.72,2.52",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "uuid-824616c4-162a-451b-8156-73be069a7769"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40.59,35.01v.54l7.38,7.38,9-4.86c1.44-.47,2.23-2.02,1.75-3.47-.27-.83-.92-1.48-1.75-1.75l-8.82-5.04-.18-.18-7.38,7.38Z",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "uuid-707a4329-2ba7-4da2-8ff6-570958b61f75"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.09,57.69c.9.9,2.17.9,3.79.18l26.27-15.12-7.56-7.56-22.5,22.5Z",
    fill: "none",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "uuid-c3d9e512-67cf-4085-b51e-bb6aeb00e3fa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.09,12.87l22.5,22.32,7.56-7.56-26.27-14.94c-.6-.36-1.27-.56-1.97-.59-.68,0-1.34.28-1.81.77",
    fill: "none",
    strokeWidth: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-306c9f9f-afc9-41b3-a865-a6030bd40ba2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "uuid-33f01c68-b8c6-460e-b112-cab94ed0bb99",
    "data-name": "Grupo 16867"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#uuid-0d12de85-5c6f-420a-8409-ec7ef2fcde7a)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-3b1ad3e4-a1b7-4efa-a15c-3956e59f8f12",
    "data-name": "Grupo 16866"
  }, /*#__PURE__*/React.createElement("path", {
    id: "uuid-ad0338d1-5470-43ec-91a0-72b832a19828",
    "data-name": "Trazado 2229",
    d: "m234,1.44c4.17.02,7.54,3.39,7.57,7.56v54c-.02,4.17-3.4,7.54-7.56,7.56H9c-4.17-.03-7.53-3.4-7.56-7.56V9c.03-4.16,3.39-7.53,7.56-7.56h225Zm0-1.44H9C4.04.01.01,4.04,0,9v54c-.05,4.92,3.9,8.95,8.83,9,.06,0,.12,0,.17,0h225c4.92.05,8.95-3.9,9-8.83,0-.06,0-.12,0-.17V9c-.01-4.96-4.04-8.98-9-9",
    fill: "#959595",
    strokeWidth: 0
  })))), /*#__PURE__*/React.createElement("g", {
    id: "uuid-27c36115-db86-4336-b428-20a7f72ca637",
    "data-name": "Grupo 16869"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#uuid-a9d4a6c8-0a00-41e2-bfd2-b11bdc2ba9e6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-72780d37-f225-4090-8436-3b905f24b06e",
    "data-name": "Grupo 16868"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "uuid-acb92abe-0343-4525-88de-b5944b2e50a0",
    "data-name": "Rect\\xE1ngulo 1668",
    x: 4.89,
    y: 11.01,
    width: 48.37,
    height: 48.37,
    transform: "translate(-16.37 30.86) rotate(-45)",
    fill: "#4285f4",
    strokeWidth: 0
  })))), /*#__PURE__*/React.createElement("g", {
    id: "uuid-903d4b67-5035-4ac1-aa91-f0e2eb028838",
    "data-name": "Grupo 16871"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#uuid-824616c4-162a-451b-8156-73be069a7769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-98cb21a3-5276-418b-a9fa-80756ea58d4d",
    "data-name": "Grupo 16870"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "uuid-ec722d81-eb11-49d6-af1c-8afc4824b694",
    "data-name": "Rect\\xE1ngulo 1669",
    x: 40.59,
    y: 27.63,
    width: 18.9,
    height: 15.3,
    fill: "#fbbc04",
    strokeWidth: 0
  })))), /*#__PURE__*/React.createElement("g", {
    id: "uuid-953e5bb5-682f-4388-a8c6-d4365c691087",
    "data-name": "Grupo 16873"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#uuid-707a4329-2ba7-4da2-8ff6-570958b61f75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-69f7bfc5-79ee-4e07-8a34-4cce0beadc0b",
    "data-name": "Grupo 16872"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "uuid-9ab2aaf7-5384-47c5-99d5-e02bf49f6be9",
    "data-name": "Rect\\xE1ngulo 1670",
    x: 17.22,
    y: 30.99,
    width: 37.8,
    height: 37.8,
    transform: "translate(-24.7 40.15) rotate(-45)",
    fill: "#ea4335",
    strokeWidth: 0
  })))), /*#__PURE__*/React.createElement("g", {
    id: "uuid-0996606d-a11a-4942-9bc9-9c5ef0d8923d",
    "data-name": "Grupo 16875"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#uuid-c3d9e512-67cf-4085-b51e-bb6aeb00e3fa)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-9c93a287-b341-4bd5-9e89-41ee9b0300a7",
    "data-name": "Grupo 16874"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "uuid-6b8eb4cd-e8ed-4ad5-a30f-9c6a9db7771d",
    "data-name": "Rect\\xE1ngulo 1671",
    x: 14.33,
    y: 4.85,
    width: 37.58,
    height: 37.58,
    transform: "translate(-7.02 30.35) rotate(-45)",
    fill: "#34a853",
    strokeWidth: 0
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m83.07,21.21c1.01-.95,1.53-2.25,1.53-3.85s-.51-2.89-1.53-3.85c-1.01-.95-2.39-1.43-4.1-1.43h-4.01v10.56h4.01c1.71,0,3.09-.48,4.1-1.43Zm-6.67-7.76h2.57c1.33,0,2.36.35,3.07,1.05s1.06,1.66,1.06,2.86-.36,2.16-1.07,2.86c-.71.7-1.74,1.05-3.07,1.05h-2.57v-7.82Z",
    fill: "#161615",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.74,
    y: 12.08,
    width: 1.44,
    height: 10.56,
    fill: "#161615",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.46,20.94c-.51.32-1.18.48-1.99.48-.62,0-1.24-.11-1.85-.33-.61-.22-1.1-.48-1.46-.79l-.11-.09-.79,1.15.09.07c.5.4,1.13.74,1.88.98.74.25,1.5.37,2.25.37s1.47-.12,2.09-.35c.62-.24,1.14-.6,1.53-1.1.39-.5.59-1.1.59-1.78,0-.45-.09-.85-.27-1.2-.18-.35-.44-.64-.76-.86-.32-.21-.67-.38-1.04-.51-.37-.12-.79-.22-1.25-.27l-.98-.12c-.78-.1-1.37-.27-1.74-.53-.36-.25-.53-.58-.53-1.02,0-.54.22-.95.69-1.26.47-.32,1.09-.48,1.86-.48,1.1,0,2.12.32,3.04.94l.11.07.74-1.17-.1-.07c-1.09-.76-2.36-1.15-3.78-1.15-.74,0-1.42.12-2.01.36-.6.24-1.09.61-1.46,1.09-.37.49-.56,1.07-.56,1.73,0,.85.29,1.52.87,1.99.56.46,1.33.75,2.29.86l1.04.12c.81.09,1.42.27,1.82.53.38.25.57.59.57,1.04,0,.55-.24.97-.74,1.28Z",
    fill: "#161615",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.25,18.49h2.58c1.18,0,2.11-.28,2.77-.84.67-.56,1-1.36,1-2.36s-.34-1.8-1-2.36c-.66-.56-1.59-.85-2.77-.85h-4.02v10.56h1.44v-4.15Zm0-5.05h2.55c.77,0,1.36.16,1.75.47.39.31.58.76.58,1.38s-.19,1.07-.58,1.38c-.39.31-.98.47-1.75.47h-2.55v-3.68Z",
    fill: "#161615",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.26,22.1c.83-.46,1.48-1.11,1.95-1.94.47-.83.71-1.77.71-2.8s-.24-1.98-.71-2.8c-.47-.83-1.13-1.48-1.95-1.94s-1.77-.69-2.79-.69c-.77,0-1.5.14-2.17.41-.67.27-1.25.65-1.73,1.12-.48.47-.86,1.05-1.14,1.72-.27.67-.41,1.4-.41,2.18s.14,1.51.41,2.18c.28.67.66,1.25,1.14,1.72.48.47,1.06.85,1.73,1.12.67.27,1.4.41,2.17.41,1.03,0,1.97-.23,2.79-.69Zm-5.61-1.81c-.35-.34-.63-.77-.83-1.28-.2-.5-.3-1.06-.3-1.65s.1-1.14.3-1.65c.2-.5.48-.93.83-1.28.35-.35.77-.62,1.25-.82.48-.2,1.01-.3,1.57-.3.75,0,1.43.17,2.02.5.59.33,1.07.81,1.42,1.42.35.62.52,1.33.52,2.11s-.18,1.49-.52,2.11c-.34.62-.82,1.09-1.42,1.42-.6.33-1.28.5-2.02.5-.56,0-1.08-.1-1.57-.3-.48-.2-.91-.47-1.25-.82Z",
    fill: "#161615",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.95 12.08 130.51 12.08 130.51 20.12 124.35 12.13 124.31 12.08 123.06 12.08 123.06 22.64 124.49 22.64 124.49 14.6 130.65 22.59 130.69 22.64 131.95 22.64 131.95 12.08",
    fill: "#161615",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.67,
    y: 12.08,
    width: 1.44,
    height: 10.56,
    fill: "#161615",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.46,17.2c.36-.18.67-.44.9-.77.29-.41.44-.92.44-1.51,0-.97-.36-1.7-1.06-2.16-.69-.45-1.63-.68-2.79-.68h-4.12v10.56h4.31c1.2,0,2.16-.24,2.84-.73.69-.49,1.04-1.25,1.04-2.26,0-.64-.17-1.19-.51-1.63-.27-.36-.63-.63-1.05-.82Zm-5.19-3.76h2.64c.37,0,.7.03.98.08.27.05.53.13.76.25.22.11.38.27.5.48.11.21.17.47.17.77s-.06.58-.17.79c-.11.21-.27.37-.49.48-.23.12-.48.2-.75.25-.28.05-.6.08-.98.08h-2.64v-3.17Zm5.1,6.98c-.11.21-.27.38-.48.5-.22.13-.48.22-.77.27-.29.06-.64.09-1.03.09h-2.82v-3.31h2.82c.8,0,1.42.13,1.84.38.4.25.6.66.6,1.27,0,.32-.05.59-.16.81Z",
    fill: "#161615",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.56 21.27 150.6 21.27 150.6 12.08 149.16 12.08 149.16 22.64 156.56 22.64 156.56 21.27",
    fill: "#161615",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.6 21.28 159.53 21.28 159.53 18 165.35 18 165.35 16.65 159.53 16.65 159.53 13.44 165.53 13.44 165.53 12.08 158.09 12.08 158.09 22.64 165.6 22.64 165.6 21.28",
    fill: "#161615",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.46 21.28 173.39 21.28 173.39 18 179.21 18 179.21 16.65 173.39 16.65 173.39 13.44 179.39 13.44 179.39 12.08 171.96 12.08 171.96 22.64 179.46 22.64 179.46 21.28",
    fill: "#161615",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.34 20.12 183.18 12.13 183.14 12.08 181.88 12.08 181.88 22.64 183.32 22.64 183.32 14.6 189.48 22.59 189.52 22.64 190.77 22.64 190.77 12.08 189.34 12.08 189.34 20.12",
    fill: "#161615",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.77,38.43c-.18,0-.37,0-.55,0-4.19-.09-7.65,3.24-7.74,7.42,0,.11,0,.21,0,.32-.03,4.24,3.38,7.71,7.63,7.74.04,0,.08,0,.11,0,4.19.09,7.65-3.24,7.74-7.42,0-.11,0-.21,0-.32.15-4.12-3.07-7.59-7.19-7.74Zm3.78,7.56c.12,2.47-1.79,4.56-4.25,4.68-.03,0-.06,0-.08,0h0c-2.58-.22-4.51-2.49-4.29-5.07.19-2.29,2-4.1,4.29-4.29,2.41,0,4.35,1.97,4.34,4.38,0,.1,0,.2-.01.3Z",
    fill: "#161615",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.79,
    y: 30.69,
    width: 3.42,
    height: 22.49,
    fill: "#161615",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m203.49,38.25h0c-2.5-.21-4.86,1.15-5.94,3.41l3.06,1.26c.61-1.1,1.81-1.74,3.06-1.62,1.77-.13,3.34,1.12,3.6,2.88v.18c-1.05-.58-2.22-.89-3.42-.9-3.25,0-6.48,1.8-6.48,5.04.12,2.91,2.58,5.17,5.49,5.04.03,0,.06,0,.09,0,1.72.06,3.35-.76,4.33-2.17h.17v1.8h3.25v-8.64c-.28-3.71-3.5-6.51-7.21-6.28Zm-.36,12.41c-1.08,0-2.7-.54-2.7-1.98,0-1.8,1.98-2.34,3.6-2.34,1.06,0,2.11.25,3.06.72-.28,1.99-1.94,3.51-3.96,3.6Z",
    fill: "#161615",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.72,30.69c-.37-.03-.74-.03-1.1,0h-8.11v22.5h3.43v-8.46h4.68c3.88.3,7.27-2.59,7.57-6.47.3-3.88-2.59-7.27-6.47-7.57Zm-.93,10.8h0s-4.86,0-4.86,0v-7.74h4.86c2.12,0,3.87,1.67,3.96,3.79-.09,2.15-1.82,3.87-3.97,3.95Z",
    fill: "#161615",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.23,40.77v3.25h7.74c-.11,1.54-.75,3.01-1.8,4.14-1.57,1.57-3.72,2.42-5.94,2.34-4.63.05-8.42-3.67-8.46-8.29,0-.12,0-.23,0-.35-.08-4.69,3.65-8.56,8.34-8.64.04,0,.08,0,.12,0,2.2.02,4.31.86,5.94,2.34l2.34-2.34c-2.17-2.1-5.08-3.27-8.1-3.25-6.56-.1-11.96,5.14-12.06,11.7-.1,6.56,5.14,11.96,11.7,12.06.12,0,.24,0,.36,0,3.14.17,6.18-1.08,8.28-3.42,1.9-2.05,2.93-4.76,2.88-7.56.04-.67-.02-1.33-.18-1.98h-11.16Z",
    fill: "#161615",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.03 38.78 218.24 48.5 218.06 48.5 214.1 38.78 210.51 38.78 216.44 52.46 213.02 60.02 216.44 60.02 225.62 38.78 222.03 38.78",
    fill: "#161615",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142.65,40.05c-1.09-1.12-2.58-1.77-4.14-1.8-4.13.19-7.39,3.6-7.38,7.74-.06,4.12,3.23,7.5,7.34,7.56.01,0,.02,0,.04,0,1.52.01,2.97-.65,3.96-1.8h.18v1.08c.23,2.25-1.41,4.26-3.66,4.49-1.87.19-3.63-.92-4.27-2.69l-2.88,1.26c1.17,2.74,3.86,4.51,6.84,4.5,3.96,0,7.2-2.34,7.2-7.92v-13.68h-3.25v1.25Zm.15,6.51c-.26,2.15-1.96,3.84-4.1,4.1-2.58-.22-4.5-2.49-4.29-5.07.19-2.29,2-4.1,4.29-4.29,2.58.32,4.42,2.67,4.1,5.25Z",
    fill: "#161615",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.5,38.43c-.18,0-.37,0-.55,0-4.19-.09-7.65,3.24-7.74,7.42,0,.11,0,.21,0,.32-.03,4.24,3.38,7.71,7.63,7.74.04,0,.08,0,.11,0,4.19.09,7.65-3.24,7.74-7.42,0-.11,0-.21,0-.32.15-4.12-3.07-7.59-7.19-7.74Zm3.78,7.56c.12,2.47-1.79,4.56-4.25,4.68-.03,0-.06,0-.08,0-2.58-.22-4.51-2.49-4.29-5.07.19-2.29,2-4.1,4.29-4.29,2.41,0,4.35,1.97,4.34,4.38,0,.1,0,.2-.01.3Z",
    fill: "#161615",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166.95,43.29c-.91-2.83-3.51-4.78-6.48-4.86-4,.02-7.24,3.28-7.22,7.28,0,.15,0,.31.02.46-.12,4.16,3.16,7.62,7.32,7.74.08,0,.16,0,.24,0,2.55.02,4.93-1.27,6.3-3.42l-2.52-1.8c-.79,1.34-2.23,2.17-3.79,2.17-1.63.09-3.14-.84-3.79-2.34l10.26-4.33-.34-.89Zm-10.44,2.52c-.08-2.31,1.66-4.28,3.96-4.5,1.19-.04,2.3.59,2.88,1.62l-6.84,2.88Z",
    fill: "#161615",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.05,
    y: 30.69,
    width: 3.42,
    height: 22.5,
    fill: "#161615",
    strokeWidth: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayEs);
export default __webpack_public_path__ + "static/media/GooglePlayES.9043814646366bcb1cdd3a30bc6c0e78.svg";
export { ForwardRef as ReactComponent };